const environment = process.env.REACT_APP_ENVIRONMENT || 'local';

const config = {
    local: {
        apiUrl: process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3001',
    },
    staging: {
        apiUrl: process.env.REACT_APP_STAGING_API_URL || 'https://staging.medicallearn.org'
    },
    production: {
        apiUrl: process.env.REACT_APP_PRODUCTION_API_URL || 'https://medicallearn.org'
    }
};

const validEnvironments = ['local', 'staging', 'production'];
const env = validEnvironments.includes(environment) ? environment : 'local';
const { apiUrl } = config[env] || config.local;

export { apiUrl, env as environment }; 